export const ACTIONS = {
  SET_MILESTONE_CREATION: 'SET_MILESTONE_CREATION',
  CLEAR_MILESTONE_CREATION: 'CLEAR_MILESTONE_CREATION',
};

export const setMilestoneCreation = (payload: boolean) => ({
  type: ACTIONS.SET_MILESTONE_CREATION,
  payload,
});

export const clearMilestoneCreation = () => ({
  type: ACTIONS.CLEAR_MILESTONE_CREATION,
  payload: {},
});
